import gsap from 'gsap'
import { Vector, Body, Vertices, Bounds } from 'matter-js'

export default class PhysicsUtils {
  static animateInBody(body: Body) {
    const bodyOriginalVertices: Vector[] = body.vertices.concat()
    const bodyInterpolatedVertices: Vector[] = body.vertices.concat()
    const verticesLength = body.vertices.length

    const animObject = {
      progress: 0
    }

    gsap.fromTo(
      animObject,
      { progress: 0.01 },
      {
        progress: 1,
        duration: 0.3,
        //ease: Sine.easeOut,
        onUpdate: () => {
          setVerticesAtScale()
        },
        onComplete: () => {}
      }
    )

    function setVerticesAtScale() {
      for (let i = 0; i < verticesLength; i++) {
        bodyInterpolatedVertices[i] = Vector.mult(bodyOriginalVertices[i], animObject.progress)
      }

      //Body.setVertices(body, bodyInterpolatedVertices)

      Vertices.rotate(body.vertices, -body.angle, body.position)

      // change vertices
      body.vertices = Vertices.create(bodyInterpolatedVertices, body)

      // update properties
      //body.axes = Axes.fromVertices(body.vertices)
      body.area = Vertices.area(body.vertices, true)

      //disable this line (compared to the original)
      //Body.setMass(body, body.density * body.area)

      // orient vertices around the centre of mass at origin (0, 0)
      const centre = Vertices.centre(body.vertices)
      Vertices.translate(body.vertices, centre, -1)

      // update inertia while vertices are at origin (0, 0)
      //disable this line (compared to the original)
      //Body.setInertia(body, Body._inertiaScale * Vertices.inertia(body.vertices, body.mass))

      // update geometry
      Vertices.translate(body.vertices, body.position, 1)
      Bounds.update(body.bounds, body.vertices, body.velocity)

      Vertices.rotate(body.vertices, body.angle, body.position)
    }
  }
}
